var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRegenerate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.156 14.706a5.948 5.948 0 01-2.61 2.652 5.804 5.804 0 01-3.647.555 5.864 5.864 0 01-3.258-1.76 6.045 6.045 0 01-1.592-3.386 6.09 6.09 0 01.696-3.687 5.936 5.936 0 012.712-2.543 5.8 5.8 0 013.667-.405c1.233.267 2.244.875 3.08 1.836.1.107.49.538.813 1.188",
    stroke: "#71869B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.046 9.208l3.36.605.594-3.42",
    stroke: "#71869B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgRegenerate;